import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import { getBlueLogoUrl } from "../../../../../constants/url-constants";
import Tick from "./images/tick.png";
import Invalid from "./images/invalid.png";
import Cross from "./images/cross.png";
import LargeTick from "./images/large-tick.svg";
import PropTypes from "prop-types";
import toggleArrow from "./images/toggle-arrow.svg";
import MarketIcon from "./images/market.svg";

const getCompareCellIcon = (value = "") => {
    const normalizedValue = String(value || "").trim().toLowerCase();
    if (normalizedValue === "no") {
        return Cross;
    }
    if (["unlimited", "nationwide", "manufacturer level"].includes(normalizedValue)) {
        return Tick;
    }
    return Invalid;
};

const DEFAULT_TABS = [
    { key: "service", label: "Service" },
    { key: "warranty", label: "Warranty" }
];
const TABLE_COMPETITOR_COLUMN_INDEX = 2;

// eslint-disable-next-line complexity
const Cars24PlatinumCoverTheBestModal = ({ isWarranty, isBundle, isWhatsCovered = false, isParentOpen, cmsData }) => {
    const [activeTab, setActiveTab] = useState(isWarranty ? 1 : 0);
    const [isOpen, setIsOpen] = useState(!isWhatsCovered);

    useEffect(() => {
        // Modal stays mounted; reset default state on open.
        if (isParentOpen) {
            setIsOpen(!isWhatsCovered);
        }
    }, [isParentOpen, isWhatsCovered]);

    const compareTabs = cmsData?.service?.compareTabs?.length ? cmsData?.service?.compareTabs : DEFAULT_TABS;
    const showWarrantyCompare = activeTab === 1;
    const selectedConfig = showWarrantyCompare ? cmsData?.warranty : cmsData?.service;
    const tableColumns = selectedConfig?.marketCompareData?.tableColumns || [];
    const tableRows = selectedConfig?.marketCompareData?.tableRows || [];
    const competitorColumnKey = tableColumns?.[TABLE_COMPETITOR_COLUMN_INDEX]?.key;

    return (
        <div styleName={"styles.tabOuter"}>
            <div styleName={"styles.tabContainer"} onClick={() => setIsOpen(!isOpen)}>
                <p styleName={"styles.tabHeading"}><img src={MarketIcon} />{selectedConfig?.marketCompareLabel || "Market comparison"}</p>
                <img styleName={isOpen ? "" : "styles.toggleArrowRotate"} src={toggleArrow} />
            </div>
            {isOpen && (
                <React.Fragment>
                    {isBundle && (
                        <div styleName={"styles.topSection"}>
                            <p styleName={"styles.title"}>{cmsData?.bundle?.comparisonTitle || "Why is Cars24 platinum cover the best?"}</p>
                            <div styleName={"styles.tabWrapper"}>
                                {compareTabs.map((tab, index) => (
                                    <div
                                        key={tab?.key || index}
                                        styleName={`styles.tab ${activeTab === index ? "styles.tabActive" : ""}`}
                                        onClick={() => setActiveTab(index)}
                                    >
                                        <p styleName={"styles.tabName"}>{tab?.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div styleName={!activeTab ? "styles.warrantyTable" : "styles.serviceTableWrapper"}>
                        <table>
                            <tr>
                                {(tableColumns || []).map((column) => (
                                    <th key={column?.key}>
                                        {column?.key === "cars24" ? <img src={getBlueLogoUrl()} alt="Cars24" /> : column?.title}
                                    </th>
                                ))}
                            </tr>
                            {tableRows.map((row, rowIndex) => (
                                <tr key={`${row?.feature || "row"}-${rowIndex}`}>
                                    {(tableColumns || []).map((column) => {
                                        const value = row?.[column?.key] || "";
                                        if (column?.key === "feature") {
                                            return <td key={`${column?.key}-${rowIndex}`}>{value}</td>;
                                        }
                                        if (column?.key === "cars24") {
                                            return (
                                                <td key={`${column?.key}-${rowIndex}`}>
                                                    <div>
                                                        <img src={Tick} alt="available" height="16px" width="16px" />
                                                        {value}
                                                    </div>
                                                </td>
                                            );
                                        }
                                        return (
                                            <td key={`${column?.key}-${rowIndex}`}>
                                                <div>
                                                    <img
                                                        src={column?.key === competitorColumnKey ? getCompareCellIcon(value) : Invalid}
                                                        alt="invalid"
                                                        height="16px"
                                                        width="16px"
                                                    />
                                                    {value}
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </table>
                    </div>

                    {!showWarrantyCompare && (cmsData?.service?.serviceIncludesList || []).length > 0 && (
                        <div styleName={"styles.serviceIncludeWrapper"}>
                            <p styleName={"styles.serviceInclude"}>{cmsData?.service?.serviceIncludesLabel || "Services include :"}</p>
                            {(cmsData?.service?.serviceIncludesList || []).map((item) => (
                                <p key={item} styleName={"styles.list"}>
                                    <img src={LargeTick} />
                                    {item}
                                </p>
                            ))}
                        </div>
                    )}

                    {showWarrantyCompare && (
                        <p styleName={"styles.disclaimer"}>
                            {cmsData?.warranty?.disclaimerText || "Based on typical aftermarket extended warranty products available on the Australian market."}
                        </p>
                    )}
                </React.Fragment>
            )}
        </div>
    );
};

Cars24PlatinumCoverTheBestModal.propTypes = {
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    isWarranty: PropTypes.bool,
    isBundle: PropTypes.bool,
    isWhatsCovered: PropTypes.bool,
    isParentOpen: PropTypes.bool,
    cmsData: PropTypes.shape({
        service: PropTypes.object,
        warranty: PropTypes.object,
        bundle: PropTypes.object
    })
};

export default Cars24PlatinumCoverTheBestModal;
